import { basemapOptions } from '../constants';
export function useMapToolbar({ basemap, setBasemap, tileLayerVisibility, setTileLayerVisibility, handleZoomIn, handleZoomOut, handleRecenter, tileLayers, showBasemapSelector, }) {
    const toggleTileLayer = (index) => {
        setTileLayerVisibility(prev => {
            var _a, _b, _c;
            return (Object.assign(Object.assign({}, prev), { [index]: !((_c = (_a = prev[index]) !== null && _a !== void 0 ? _a : (_b = tileLayers[index]) === null || _b === void 0 ? void 0 : _b.visible) !== null && _c !== void 0 ? _c : true) }));
        });
    };
    return {
        basemap,
        setBasemap,
        tileLayerVisibility,
        toggleTileLayer,
        handleZoomIn,
        handleZoomOut,
        handleRecenter,
        basemapOptions,
        showBasemapSelector,
        tileLayers,
    };
}
